module.exports = __webpack_public_path__ + "img/ChevronDown.22f19858.svg";